import { render, staticRenderFns } from "./DeviceIcon.vue?vue&type=template&id=2338c429&scoped=true"
import script from "./DeviceIcon.vue?vue&type=script&lang=js"
export * from "./DeviceIcon.vue?vue&type=script&lang=js"
import style0 from "./DeviceIcon.vue?vue&type=style&index=0&id=2338c429&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2338c429",
  null
  
)

export default component.exports